<form 
    class="marketplace-filter-desktop" 
    [formGroup]="formGroup"
>
	<div class="marketplace-search-box">
		<input
			type="search"
			class="marketplace-search-input"
			[placeholder]="'Search services'"
			[title]="'Search services'"
			autocomplete="off"
			spellcheck="false"
			[ngModel]="searchText"
			[ngModelOptions]="{ standalone: true }"
			(ngModelChange)="handleSearchTextChange($event)"
			(keyup.enter)="triggerFilter()"
		/>
		<button 
            type="button" 
            class="marketplace-icon-btn" 
            title="Search" 
            (click)="triggerFilter()"
        >
			<img 
                src="../../../../../../../assets/media/svg/search-icon.svg" 
                alt="Search Icon" 
                class="search_search-icon"
            >
		</button>
	</div>

	<div class="marketplace-select-wrap" *ngFor="let field of formFields; trackBy: trackByFieldName">
		<label [for]="field.name" class="marketplace-label">{{ field.label }}</label>
		<p-dropdown
			[inputId]="field.name"
			[options]="field.options ?? []"
			[filter]="(field.options ?? []).length > 10"
			optionLabel="label"
			optionValue="value"
			[formControlName]="field.name"
			placeholder="All"
			styleClass="form-control marketplace-dropdown"
			(onChange)="triggerFilter()"
		></p-dropdown>
	</div>
</form>
